<template>
    <section id="home-slide-jobs" class="p-5 container-fluid">
        <div class="my-5">
            <h1 class="text-center">{{ gettext("A qui s’adresse Octolo Habitat") }}</h1>
        </div>

        <div class="py-5 block md:flex justify-around">
            <div @mouseover="showText(1)">
                <div class="job-image flex justify-around" :class="{active: isText(1)}">
                    <img class="rounded-circle" src="/static/img/habitat/OPH.png" style="width: 140px; height: 140px;"/>
                </div>
                <div class="title shrink-5" :class="{active: isText(1)}">{{ gettext("OPH") }}</div>
                <p class="mb-0 py-5 shrink-5 text-center md:hidden italic">
                    <span>«&nbsp;</span>
                    Octolo Habitat permet d’organiser les conseils d'administration en quelques clics et de
                    sécuriser vos commissions (CALEOL, CAO…). Optimisez et sécurisez les échanges avec vos collectivités
                    de rattachement grâce aux datarooms !
                    <span>&nbsp;»</span>
                </p>
            </div>
            <div @mouseover="showText(2)">
                <div class="job-image flex justify-around" :class="{active: isText(2)}">
                    <img class="rounded-circle" src="/static/img/habitat/ESH.png" style="width: 140px; height: 140px;" />
                </div>
                <div class="title shrink-5" :class="{active: isText(2)}">{{ gettext("ESH") }}</div>
                <p class="mb-0 py-5 shrink-5 text-center md:hidden italic">
                    <span>«&nbsp;</span>
                    Grâce à Octolo Habitat, les assemblées générales, conseils d’administration,
                    directoires et tous vos comités et commissions (CALEOL, CAO…) sont organisés en toute simplicité.
                    Un outil pensé pour les ESH, avec des registres d’actionnaires prêts à l’emploi prenant en compte
                    les spécificités liées à la répartition des droits de votes des différentes catégories d’actionnaires.
                    Fluidifiez et sécurisez la communication avec vos mandataires et partenaires !
                    <span>&nbsp;»</span>
                </p>
            </div>
            <div @mouseover="showText(3)">
                <div class="job-image flex justify-around" :class="{active: isText(3)}">
                    <img class="rounded-circle" src="/static/img/habitat/COOP.png" style="width: 140px; height: 140px;" />
                </div>
                <div class="title shrink-5" :class="{active: isText(3)}">{{ gettext("Coopératives") }}</div>
                <p class="mb-0 py-5 shrink-5 text-center md:hidden italic">
                    <span>«&nbsp;</span>
                    L’outil s’adapte aussi bien aux Sociétés Coopératives de production qu’aux SCIC et
                    permet de prendre en compte toute la diversité du sociétariat en particulier au niveau
                    des registres et des votes. Sécurisez vos cessions et rachats de parts et appuyez-vous
                    sur Octolo Habitat pour dynamiser le fait coopératif ! Et bientôt notre module AG de syndics !
                    <span>&nbsp;»</span>
                </p>
            </div>
            <div @mouseover="showText(4)">
                <div class="job-image flex justify-around" :class="{active: isText(4)}">
                    <img class="rounded-circle" src="/static/img/habitat/EPL.png" style="width: 140px; height: 140px;" />
                </div>
                <div class="title shrink-5" :class="{active: isText(4)}">{{ gettext("SEM") }}</div>
                <p class="mb-0 py-5 shrink-5 text-center md:hidden italic">
                    <span>«&nbsp;</span>
                    Les sociétés d’économie mixte trouvent en Octolo Habitat un outil simple et sécurisé pour
                    gérer leur vie sociale mais aussi leurs commissions et comités. Un outil modulable adapté à
                    vos activités et vos particularités.
                    <span>&nbsp;»</span>
                </p>
            </div>
            <div @mouseover="showText(5)">
                <div class="job-image flex justify-around" :class="{active: isText(5)}">
                    <img class="rounded-circle" src="/static/img/habitat/IMMO.png" style="width: 140px; height: 140px;" />
                </div>
                <div class="title shrink-5" :class="{active: isText(5)}">{{ gettext("Acteurs immobilier") }}</div>
                <p class="mb-0 py-5 shrink-5 text-center md:hidden italic">
                    <span>«&nbsp;</span>
                    Foncières, promoteurs et autres acteurs de l’immobilier : vous percevez les limites et les
                    coûts internes d’une gestion juridique trop peu digitalisée : erreurs, difficultés pour partager
                    les informations juridiques, volumétrie des formalités chronophages (SCCV,...).
                    Insufflez de la performance dans ces process avec Octolo Habitat !
                    <span>&nbsp;»</span>
                </p>
            </div>
        </div>

        <div class="hidden md:block">
            <p v-if="text==1" class="mx-5 mb-0 pb-5 shrink-2 text-center italic">
                <span>«&nbsp;</span>
                Octolo Habitat permet d’organiser les conseils d'administration en quelques clics et de
                sécuriser vos commissions (CALEOL, CAO…). Optimisez et sécurisez les échanges avec vos collectivités
                de rattachement grâce aux datarooms !
                <span>&nbsp;»</span>
            </p>

            <p v-if="text==2" class="mx-5 mb-0 pb-5 shrink-2 text-center italic">
                <span>«&nbsp;</span>
                Grâce à Octolo Habitat, les assemblées générales, conseils d’administration,
                directoires et tous vos comités et commissions (CALEOL, CAO…) sont organisés en toute simplicité.
                Un outil pensé pour les ESH, avec des registres d’actionnaires prêts à l’emploi prenant en compte
                les spécificités liées à la répartition des droits de votes des différentes catégories d’actionnaires.
                Fluidifiez et sécurisez la communication avec vos mandataires et partenaires !
                <span>&nbsp;»</span>
            </p>

            <p v-if="text==3" class="mx-5 mb-0 p-5 shrink-2 text-center italic">
                <span>«&nbsp;</span>
                L’outil s’adapte aussi bien aux Sociétés Coopératives de production qu’aux SCIC et
                permet de prendre en compte toute la diversité du sociétariat en particulier au niveau
                des registres et des votes. Sécurisez vos cessions et rachats de parts et appuyez-vous
                sur Octolo Habitat pour dynamiser le fait coopératif !
                <span>&nbsp;»</span>
            </p>

            <p v-if="text==4" class="mx-5 mb-0 p-5 shrink-2 text-center italic">
                <span>«&nbsp;</span>
                Les sociétés d’économie mixte trouvent en Octolo Habitat un outil simple et sécurisé pour
                gérer leur vie sociale mais aussi leurs commissions et comités. Un outil modulable adapté à
                vos activités et vos particularités.
                <span>&nbsp;»</span>
            </p>

            <p v-if="text==5" class="mx-5 mb-0 p-5 shrink-2 text-center italic">
                <span>«&nbsp;</span>
                Foncières, promoteurs et autres acteurs de l’immobilier : vous percevez les limites et les
                coûts internes d’une gestion juridique trop peu digitalisée : erreurs, difficultés pour partager
                les informations juridiques, volumétrie des formalités chronophages (SCCV,...).
                Insufflez de la performance dans ces process avec Octolo Habitat !
                <span>&nbsp;»</span>
            </p>

        </div>
    </section>
</template>

<script>
export default {
    data(){return{
        text: 1,
    }},
    methods: {
        isText(text){
            return (this.text == text);
        },
        showText(text){
            this.text = text;
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/vars.scss";
#home-slide-jobs {
    > div > h1 { color: white; }
    background-color: $primary;

    > div > div {
        > .job-image {
            text-align: center;
            > img {
                border: 2px solid transparent;
                border-radius: 50%;
                overflow: hidden;
                padding: 2px;
            }
        }
        > .job-image:hover,
        > .job-image.active {

            > img {
                border: 2px solid $secondary;
            }
        }
        > .title {
            text-align: center;
            font-weight: bold;
            color: white;
        }
        > .title.active {
            color: $secondary;
        }
    }



    > div > p,
    > div > div > p {
        color: white;
        font-weight: bold;

        > span {
            color: $secondary;
        }
    }
}
</style>
